import { z } from 'zod';
import { ApiClient } from '../lib/api';
import {
  InsuranceClaim,
  InsuranceClaimSchema,
  CreateInsuranceClaim,
  CreateInsuranceClaimSchema,
  UpdateInsuranceClaim,
  UpdateInsuranceClaimSchema
} from '../models/insurance-claim';

export class InsuranceService {
  private readonly api: ApiClient;

  constructor(baseURL: string, stage: string) {
    this.api = new ApiClient(`${baseURL}/${stage}/insurance-service-${stage}`, stage);
  }

  private setDefaults(data: unknown): InsuranceClaim {
    return InsuranceClaimSchema.parse(data);
  }

  async getInsuranceClaims(): Promise<InsuranceClaim[]> {
    const claims = await this.api.request(
      { method: 'GET', url: '/insurance-claims' },
      InsuranceClaimSchema.array()
    );
    return claims.map(claim => this.setDefaults(claim));
  }

  async getInsuranceClaimById(id: number): Promise<InsuranceClaim> {
    const claim = await this.api.request(
      { method: 'GET', url: `/insurance-claims/${id}` },
      InsuranceClaimSchema
    );
    return this.setDefaults(claim);
  }

  async createInsuranceClaim(data: CreateInsuranceClaim): Promise<InsuranceClaim> {
    const claim = await this.api.request(
      {
        method: 'POST',
        url: '/insurance-claims',
        data: CreateInsuranceClaimSchema.parse(data)
      },
      InsuranceClaimSchema
    );
    return this.setDefaults(claim);
  }

  async updateInsuranceClaim(id: number, data: UpdateInsuranceClaim): Promise<InsuranceClaim> {
    const claim = await this.api.request(
      {
        method: 'PUT',
        url: `/insurance-claims/${id}`,
        data: UpdateInsuranceClaimSchema.parse(data)
      },
      InsuranceClaimSchema
    );
    return this.setDefaults(claim);
  }

  async deleteInsuranceClaim(id: number): Promise<void> {
    await this.api.request(
      { method: 'DELETE', url: `/insurance-claims/${id}` },
      z.void()
    );
  }
} 